import { render, staticRenderFns } from "./ProfileGallery.vue?vue&type=template&id=07f98ff9&scoped=true&"
import script from "./ProfileGallery.vue?vue&type=script&lang=js&"
export * from "./ProfileGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGallery.vue?vue&type=style&index=0&id=07f98ff9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f98ff9",
  null
  
)

export default component.exports